var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Col',{attrs:{"span":4}},[_c('div',{staticClass:"order-item",on:{"click":_vm.toPage}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"num"},[_vm._v(_vm._s(_vm.num || '0'))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }